import { buildDate  ,
         appState   }  from '../config/build_infos';

export const getAppState = () => {

//  0    En mode normal      ( / correspond home et le reste est actif )
//  1 :  En mode test        ( / correspond à la page de maintenance, /hometest correspond à home et le reste est désactivé )
// -1 :  En mode maintenance ( / correspond à la page de maintenance et le reste est désactivé )

  return appState;
}

export const getAppInformations = () => {

  const mode    = ( appState === 1 ? "test" : ( appState === -1 ? "maintenance" : "normal" ) );

  return `Version du ${buildDate} en mode ${mode}`;
}
